interface ExerciseButtonsProps {
  children: React.ReactNode;
  className?: string;
}

export function ExerciseButtons({ children, className = "" }: ExerciseButtonsProps) {
  return (
    <div className={`w-full pb-8 ${className}`}>
      <div className="max-w-xl mx-auto w-full space-y-2">
        {children}
      </div>
    </div>
  );
}
